import { render, staticRenderFns } from "./modalViewNotificationAttributes.vue?vue&type=template&id=93b6f9f8&"
import script from "./modalViewNotificationAttributes.vue?vue&type=script&lang=js&"
export * from "./modalViewNotificationAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports